<ng-container *ngIf="ready">
  <div
    class="flow mw568"
    [ngStyle]="{
      justifyContent: justifyContent
    }"
  >
    <!-- Subtract 17.5px from the percentage to account for the gap between flow-items  -->
    <app-content-flow-item
      *ngFor="let contentItem of items; trackBy: trackByFn"
      [item]="contentItem.item"
      [hidden]="contentItem.visibility?.isHidden"
      [ngStyle]="{
        flexBasis: 'calc(' + contentItem.itemWidth + ' - 17.5px)',
        visibility: contentItem.visibility?.isInvisible ? 'hidden' : 'visible'
      }"
    >
    </app-content-flow-item>
  </div>
</ng-container>
